// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1xjOI","App-header":"App_App-header__1yqHs"};